import { ReactElement } from 'react'
import { useJotaiDevtools } from '@/hooks/useJotaiDevtools'

const JotaiDevtools = ({ children }: { children: ReactElement }) => {
  useJotaiDevtools()
  return children
}

export default JotaiDevtools
